import React from "react";
import ContactForm from "../components/ContactForm";
import ContactDisclaimer from "../components/ContactDisclaimer";
import { FaEnvelope, FaLinkedin, FaClock, FaPhone } from "react-icons/fa";

const Contact = () => {
  return (
    <div className="min-h-screen pt-24 pb-20 px-4">
      {/* Page header */}
      <div className="max-w-7xl mx-auto mb-12 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-light mb-6">
          Get in Touch
        </h1>
        <p className="text-xl text-light/80 max-w-3xl mx-auto">
          Have questions or ready to explore how Eluno Consulting can help your
          business? Reach out to us through the form below or via email.
        </p>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact information */}
          <div className="lg:col-span-1">
            <div className="bg-dark-light rounded-lg p-6 md:p-8 shadow-lg h-full">
              <h2 className="text-2xl font-bold text-light mb-6">
                Contact Information
              </h2>

              <div className="space-y-6">
                {/* Phone */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-accent/20 flex items-center justify-center mr-4">
                    <FaPhone className="text-accent h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-light">Phone</h3>
                    <a
                      href="tel:8166785415"
                      className="text-accent hover:text-accent/80 transition-colors"
                    >
                      (816) 678-5415
                    </a>
                  </div>
                </div>
                
                {/* Email */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-accent/20 flex items-center justify-center mr-4">
                    <FaEnvelope className="text-accent h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-light">Email</h3>
                    <a
                      href="mailto:hello@eluno.consulting"
                      className="text-accent hover:text-accent/80 transition-colors"
                    >
                      hello@eluno.consulting
                    </a>
                  </div>
                </div>

                {/* LinkedIn */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-accent/20 flex items-center justify-center mr-4">
                    <FaLinkedin className="text-accent h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-light">LinkedIn</h3>
                    <a
                      href="https://www.linkedin.com/in/bwilde/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-accent hover:text-accent/80 transition-colors"
                    >
                      linkedin.com/in/bwilde
                    </a>
                  </div>
                </div>

                {/* Response Time */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-accent/20 flex items-center justify-center mr-4">
                    <FaClock className="text-accent h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-light">
                      Response Time
                    </h3>
                    <p className="text-light/80">
                      We typically respond to all inquiries within one business
                      day.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-dark border border-accent/30 rounded-lg">
                <h3 className="text-lg font-medium text-light mb-3">
                  Prefer a direct conversation?
                </h3>
                <p className="text-light/80 mb-6">
                  Schedule a free 30-minute consultation to discuss your needs.
                </p>
                <button
                  onClick={() => {
                    if (window.Calendly) {
                      window.Calendly.initPopupWidget({
                        url: "https://calendly.com/brad-wilde/eluno-consulting-introductory-call",
                      });
                    }
                  }}
                  className="w-full px-4 py-3 bg-accent text-dark rounded-md font-medium hover:bg-accent/90 transition-all shadow-lg shadow-accent/20"
                >
                  Schedule Your Free Call
                </button>
              </div>
            </div>
          </div>

          {/* Contact form */}
          <div className="lg:col-span-2">
            <ContactForm />
            <ContactDisclaimer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
